/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import AppointmentApply from "./AppointmentApply";
import AppointmentInterview from "./AppointmentInterview";
import AppointmentProposeApplication from "./AppointmentProposeApplication";
import AppointmentSecondApprovalApplication from "./AppointmentSecondApprovalApplication";
import AppointmentMarkApplication from "./AppointmentMarkApplication";
import {
  APPOINTMENT_APPLY_TABLE_COL,
  APPOINTMENT_INTERVIEW_COL,
  APPOINTMENT_PROPOSE_APPLICATION_COL,
  APPOINTMENT_PROPOSE_MARK_APPLICATION_COL,
  APPOINTMENT_REVIEW_TABLE_COL,
  APPOINTMENT_APPROVAL_TABLE_COL,
  APPOINTMENT_SECOND_APPROVAL_APPLICATION_COL,
  APPOINTMENT_TRACKING_COL,
} from "../../contants/table/appointment";
import AppointmentReview from "./AppointmentReview";
import { APPOINTMENT_TABLES_MAP } from "../../contants/appointment";
import ReviewAppointment from "./ReviewAppointment";
import PartialReviewAppointment from "./PartialReviewedAppointment";
import PartialApprovedAppointment from "./PartialApprovedAppointment";
import AppointmentTracking from "./AppointmentTracking";

export const getTableContent = (type) => {
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_REVIEW) {
    return {
      colums: APPOINTMENT_REVIEW_TABLE_COL,
      subHeading: "",
      component: AppointmentReview,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.REVIEW_APPOINTMENT) {
    return {
      colums: APPOINTMENT_APPROVAL_TABLE_COL,
      subHeading: "",
      component: ReviewAppointment,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.PARTIAL_REVIEW_APPOINTMENT) {
    return {
      colums: APPOINTMENT_APPROVAL_TABLE_COL,
      subHeading: "Approval for Recommendation",
      component: PartialReviewAppointment,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.PARTIAL_APPROVED_APPOINTMENT) {
    return {
      colums: APPOINTMENT_APPROVAL_TABLE_COL,
      subHeading: "Approval for Recommendation",
      component: PartialApprovedAppointment,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_INTERVIEW) {
    return {
      colums: APPOINTMENT_INTERVIEW_COL,
      subHeading: "Interaction for Appointment",
      component: AppointmentInterview,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_APPLICATION) {
    return {
      colums: APPOINTMENT_PROPOSE_APPLICATION_COL,
      subHeading: "",
      component: AppointmentProposeApplication,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_SECOND_APPROVAL_APPLICATION) {
    return {
      colums: APPOINTMENT_SECOND_APPROVAL_APPLICATION_COL,
      subHeading: "",
      component: AppointmentSecondApprovalApplication,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_PROPOSE_MARK_APPLICATION) {
    return {
      colums: APPOINTMENT_PROPOSE_MARK_APPLICATION_COL,
      subHeading: "",
      component: AppointmentMarkApplication,
    };
  }
  if (type === APPOINTMENT_TABLES_MAP.APPOINTMENT_TRACKING) {
    return {
      colums: APPOINTMENT_TRACKING_COL,
      // subHeading: "Appointment Tracking",
      component: AppointmentTracking,
    };
  }
  return {
    colums: APPOINTMENT_APPLY_TABLE_COL,
    subHeading: "",
    component: AppointmentApply,
  };
};
